module.exports = __webpack_public_path__ + "39f786c4f1f3b6b11af477a570d43656.svg";